module.exports = __webpack_public_path__ + "static/book_of_vile_darkness-25585efa3d50f5bdcf77505007b25630.jpeg";